import { useState } from 'react';

import Markdown from '@components/utils/Markdown';
import CustomIcon from '@components/utils/CustomIcon';
import { DownArrowIcon, UpArrowIcon } from '@assets/icons';

import { Cursor, Degree, Div, DivComplate, ReadMore, Wrapper } from './style';

export interface ISeoTextProps {
  text?: string;
}

const SeoText = ({ text }: ISeoTextProps) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <Wrapper id='seoContent'>
      {isReadMore ? (
        <Div>
          <Markdown text={text} />
          <Degree />
        </Div>
      ) : (
        <DivComplate>
          <Markdown text={text} />
        </DivComplate>
      )}
      <ReadMore onClick={toggleReadMore} className='read-or-hide'>
        {text ? (
          <>
            {isReadMore ? (
              <Cursor>
                <CustomIcon icon={DownArrowIcon} fontSize={24} />
              </Cursor>
            ) : (
              <Cursor>
                <CustomIcon icon={UpArrowIcon} fontSize={24} />
              </Cursor>
            )}
          </>
        ) : null}
      </ReadMore>
    </Wrapper>
  );
};

export default SeoText;
